import axios, { AxiosInstance } from "axios";
import qs from "qs";
import { v4 } from "uuid";
import { API_URL, APP_VERSION, BASE_APP_NAME } from "../../config";

class AxiosFactory {
    createAxiosInstance(appNameScope: string): AxiosInstance {
        const axiosInstance = axios.create({
            baseURL: API_URL,
            withCredentials: true,
            headers: {
                "x-app-name": `${BASE_APP_NAME}.${appNameScope}`,
                "x-app-version": APP_VERSION,
                "x-request-id": v4(),
                "x-correlation-id": v4(),
            },
            paramsSerializer: qs.stringify,
        });
        return axiosInstance;
    }
}

const axiosFactory = new AxiosFactory();
export default axiosFactory;
